import { render, staticRenderFns } from "./DeleteMenuElement.vue?vue&type=template&id=979860b4&"
import script from "./DeleteMenuElement.vue?vue&type=script&lang=js&"
export * from "./DeleteMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports